export enum TaskType {
  TASK = 'TASK',
  MILESTONE = 'MILESTONE',
}
